import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profiles: {},
};

const appDataSlice = createSlice({
  name: "appData",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      const { uid, data } = action.payload || {};
      if (uid) {
        state.profiles[uid] = data;
      }
    },
    clearAppData: () => initialState,
  },
});

export const { setProfileData, clearAppData } = appDataSlice.actions;

export default appDataSlice.reducer;

